import React, { forwardRef, useEffect, useState } from "react";
import { Box, Dialog, DialogProps, Slide, Typography } from "@mui/material"
import { TransitionProps } from "@mui/material/transitions";
import CloseIcon from '../../assets/images/svgs/close.svg';
import { theme } from "../../utils/theme/godzilla_light";

const styles = {
    headerTitle: {
        flex: 1,
        ...theme.typography.opticianBodyRegular,
        fontSize: "24px",
        lineHeight: "24px",
        textAlign: "left"
    },
    headerSubTitle: {
        flex: 1,
        fontWeight: "300",
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "left"
    }
}

interface ICommonDialogProps {
    onDialogClose?: () => void;
    isDialogVisible: boolean;
    children?: React.ReactNode;
    headerLabel?: string;
    headerSubtitle?: string;
    maxDialogWidth?: DialogProps['maxWidth'];
    headerTitleSx?: any;
    headerSubTitleSx?: any;
    slotProps?:any;
}

const CommonDialogTransition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const CommonDialog = (props: ICommonDialogProps) => {
    const { isDialogVisible, onDialogClose, children, headerLabel, headerSubtitle, maxDialogWidth, headerTitleSx, headerSubTitleSx,slotProps } = props
    const [openDialog, setOpenDialog] = useState(isDialogVisible);

    useEffect(() => {
        setOpenDialog(isDialogVisible)
    }, [isDialogVisible])

    const closeDialog = () => {
        setOpenDialog(false);
        if(onDialogClose){
            onDialogClose()
        }
    };

    return (
        <Dialog
            open={openDialog}
            onClose={closeDialog}
            maxWidth={maxDialogWidth}
            slotProps={slotProps}
            slots={{ transition: CommonDialogTransition }}>
            <Box sx={{ backgroundColor: "#fff" ,borderRadius:"8px"}}>
                <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={"center"} flex={1} sx={{ pl: "20px", pr: "24.5px", pt: "20px" }}>
                    <Box flex={1} sx={{pr:"10px"}}>
                        <Typography sx={{...styles.headerTitle, ...headerTitleSx}}>{headerLabel}</Typography>
                        {headerSubtitle ? <Typography sx={{...styles.headerSubTitle, ...headerSubTitleSx}}>{headerSubtitle}</Typography> : null}
                    </Box>
                    <Box onClick={closeDialog} sx={{ cursor: "pointer" }}>
                         <img src={CloseIcon} alt="close-icon" />
                    </Box>
                </Box>
                {children}
            </Box>
        </Dialog>
    )
}